import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'

import { i18nKeys } from '../app.i18n'
import { links } from '../app.links'
import { ACTIVE_CLASS_NAME, NAVLINK_CLASS_NAME } from '../shared'

type Props = RouteComponentProps<{}> & {
  t: TranslationFunction
}

export const RegionalNav: SFC<Props> = ({ match, t }) => (
  <>
    <div className="sidebar__title">{t(i18nKeys.frontFace.activityBar.regional)}</div>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      activeClassName={ACTIVE_CLASS_NAME}
      to={links.frontFace.regional.team(match.path)}
    >
      {t(i18nKeys.frontFace.regional.team)}
    </NavLink>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      activeClassName={ACTIVE_CLASS_NAME}
      to={links.frontFace.regional.reviews(match.path)}
    >
      {t(i18nKeys.frontFace.regional.reviews)}
    </NavLink>
  </>
)



// WEBPACK FOOTER //
// ./src/app/sidebar-navigation/regional.tsx